// this way can allow module federation enable
import('./index');
